// src/constants.ts

// API Configuration
export const API_BASE_URL =
  process.env.REACT_APP_API_BASE_URL ||
  "https://drumly-backend-541755790098.us-central1.run.app/api/v1";

// App version
export const APP_VERSION = "1.0.10";
